import { ZoneId } from '@js-joda/core';
import { CreateSerializer } from './CreateSerializer';
/**
 * Serializer for ZoneId
 */
export const zoneIdSerializer = CreateSerializer(serializeZoneId, deserializeZoneId);
function serializeZoneId(value) {
    return value.equals(ZoneId.SYSTEM) ? ZoneId.systemDefault().toJSON() : value.toJSON();
}
function deserializeZoneId(value) {
    return ZoneId.of(value);
}
